import script from "./DetalleTorneoGestionIndividualMasView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleTorneoGestionIndividualMasView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleTorneoGestionIndividualMasView.vue?vue&type=style&index=0&id=5f9fe26e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9fe26e"]])

export default __exports__